import { render, staticRenderFns } from "./ItsBaseExpenseItems.vue?vue&type=template&id=668d9102&scoped=true&"
import script from "./ItsBaseExpenseItems.vue?vue&type=script&lang=js&"
export * from "./ItsBaseExpenseItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d9102",
  null
  
)

export default component.exports